/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type StageEntityTypeEnum = "containers" | "shipments" | "%future added value";
export type infoPickEntityStageInput = {
    clientMutationId?: string | null;
    entityType: StageEntityTypeEnum;
    entitySlug: string;
    stage?: string | null;
    pickedBy: string;
};
export type ShipmentWorkflowPickStageMutationVariables = {
    input: infoPickEntityStageInput;
};
export type ShipmentWorkflowPickStageMutationResponse = {
    readonly infoPickEntityStage: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ShipmentWorkflowPickStageMutation = {
    readonly response: ShipmentWorkflowPickStageMutationResponse;
    readonly variables: ShipmentWorkflowPickStageMutationVariables;
};



/*
mutation ShipmentWorkflowPickStageMutation(
  $input: infoPickEntityStageInput!
) {
  infoPickEntityStage(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoPickEntityStagePayload",
    "kind": "LinkedField",
    "name": "infoPickEntityStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShipmentWorkflowPickStageMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShipmentWorkflowPickStageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0986626a94714ff8d87cb4ced46d64f6",
    "id": null,
    "metadata": {},
    "name": "ShipmentWorkflowPickStageMutation",
    "operationKind": "mutation",
    "text": "mutation ShipmentWorkflowPickStageMutation(\n  $input: infoPickEntityStageInput!\n) {\n  infoPickEntityStage(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '62f1bdaef5dc7d243f826c105a964159';
export default node;
